<template>
    <v-app id="inspire">
      <AdminHeader type="search"/>
      <v-main class="grey lighten-3">
        <v-container>
          <v-row>
            <AdminMenu/>
            <v-container class="col-10">
              <v-row>
                <v-col
                    class="page-top d-flex justify-space-between"
                    cols="12"
                >
                  <div>
                    <div class="page-title">Занятия</div>
                    <div class="breadcrumb">Занятия</div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-sheet
                      max-height="80px"
                      rounded="lg"
                      class="d-flex justify-space-between align-center card"
                  >
                    <v-tabs
                        centered
                        id="horizontal_tabs"
                        v-model="schedule_tab"
                        class="d-flex align-center schedule__tab"
                    >
                      <v-tab
                          v-for="item in schedules"
                          :key="item.tab"
                          class="ml-4"
                      >
                        {{ item.tab }}
                      </v-tab>
                    </v-tabs>
                    <v-btn-toggle
                        v-if="schedule_tab === 1"
                        v-model="toggle_category"
                        mandatory
                        class="ml-5 rounded-lg"
                    >
                      <v-btn>
                        Сотрудники
                      </v-btn>
                      <v-btn>
                        Помещение
                      </v-btn>
                    </v-btn-toggle>
                  </v-sheet>
                </v-col>
                <v-col>
                  <v-tabs-items v-model="schedule_tab">
                    <v-tab-item>
                      <v-sheet class="rounded-lg">
                        <v-card-title
                            class="d-flex justify-space-between align-center"
                        >
                          <div class="calendar-options d-flex align-center">
                            <v-btn-toggle
                                v-model="toggle_date"
                                mandatory
                                class="ml-5 rounded-lg"
                            >
                              <v-btn @click="changeDay">
                                День
                              </v-btn>
                              <v-btn @click="changeWeek">
                                Неделя
                              </v-btn>
                            </v-btn-toggle>
                            <v-btn-toggle
                                v-model="toggle_week"
                                class="ml-5 rounded-lg"
                            >
                              <v-btn @click="prev" style="padding: 0 !important; min-width: 38px !important;">
                                <v-icon
                                >
                                  mdi-chevron-left
                                </v-icon>
                              </v-btn>
                              <v-btn @click="next" style="padding: 0 !important; min-width: 38px !important;">
                                <v-icon
                                >
                                  mdi-chevron-right
                                </v-icon>
                              </v-btn>
                            </v-btn-toggle>
                            <VueDatePicker
                                no-title
                                no-header
                                disabled
                                color="#629f34"
                                class="ml-4"
                                style="flex: none !important;"
                                v-if="start && end && !dialogDate"
                            >
                              <template #activator>
                                <button
                                    class="button custom__date-button"
                                    ref="activator"
                                    type="button"
                                >
                                  <v-icon
                                      dark
                                      small
                                      class="mr-2"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon>  {{ start.day === end.day ? start.day : start.day + '-' + end.day }} {{ start.month === end.month ? months[start.month - 1] : months[start.month - 1] + ' - ' + months[end.month - 1]}}
                                </button>
                              </template>
                            </VueDatePicker>
                            <VueDatePicker
                                no-title
                                no-header
                                v-model="dateTable"
                                @onChange="typeToDate(dateTable)"
                                color="#629f34"
                                class="ml-4"
                                style="flex: none !important;"
                                v-if="dialogDate"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__date-button"
                                    ref="activator"
                                    type="button"
                                >
                                  <v-icon
                                      dark
                                      small
                                      class="mr-2"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon> {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>
                            <v-btn-toggle
                                v-model="toggle_day"
                                mandatory
                                class="ml-5 rounded-lg"
                            >
                              <v-btn>
                                Утро
                              </v-btn>
                              <v-btn>
                                Вечер
                              </v-btn>
                              <v-btn>
                                Весь день
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                          <div class="filter-schedule">
                            <v-btn
                                dark
                                class="filter-button"
                                @click="dialogFiler = !dialogFiler"
                            >
                              <img
                                  class="mr-1"
                                  src="/playground_assets/mediumfilter.svg"
                              >
                              Фильтр
                            </v-btn>
                          </div>
                        </v-card-title>
                        <v-card-text
                            v-show="dialogFiler"
                        >
                          <v-form
                              ref="groupFilterForm"
                              v-model="valid"
                          >
                            <v-container>
                              <v-row>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                >
                                  <label>Сотрудники</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="groupLessonFilter.specialist"
                                      :items="events"
                                      item-value="specialist_id"
                                      item-text="category"
                                      ref="selectedEl1"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      item-color="#629F33"
                                      clearable
                                      multiple
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  >
                                    <template v-slot:selection="data">
                                      <span
                                          v-if="groupLessonFilter.specialist.length === 1"
                                          v-bind="data.attrs"
                                      >
                                        {{ data.item.category }}
                                      </span>
                                      <div v-else-if="data.index === 0">
                                        Выбрано {{ groupLessonFilter.specialist.length }} сотрудников
                                      </div>
                                    </template>
                                  </v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                >
                                  <label>Должность</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="groupLessonFilter.position"
                                      :items="events"
                                      item-value="post_id"
                                      item-text="post_name"
                                      ref="selectedEl3"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                >
                                  <label>Помещение</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="groupLessonFilter.room"
                                      :items="events"
                                      item-value="room_id"
                                      item-text="room_name"
                                      ref="selectedEl4"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                    class="mt-3"
                                >
                                  <label>Клиент</label>
                                  <v-autocomplete
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      :items="listClient ? listClient.client : []"
                                      item-value="client_id"
                                      item-text="name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      no-data-text="Результатов не найдено"
                                      :search-input.sync="groupLessonFilter.search_client"
                                      v-model="groupLessonFilter.select_client"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                    class="mt-3"
                                >
                                  <label>Услуга</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="groupLessonFilter.service"
                                      :items="events"
                                      ref="selectedEl6"
                                      item-text="name"
                                      item-value="service_id"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                    class="mt-3"
                                >
                                  <label>Статус</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="groupLessonFilter.status"
                                      :items="statusTypes"
                                      ref="selectedEl2"
                                      item-text="type_name"
                                      item-value="type_id"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-card-actions class="mt-4">
                                  <template v-if="!dialogButton">
                                    <button
                                        class="button custom__button mt-5"
                                        type="button"
                                    >
                                      Применить
                                    </button>
                                  </template>
                                  <template v-else>
                                    <button
                                        class="button custom__button mt-5"
                                        type="button"
                                        style="background-color: #A13453 !important;color: #fff !important;"
                                        @click="filterEvents(groupLessonFilter)"
                                    >
                                      Применить
                                    </button>
                                    <button
                                        class="button custom__button mt-5 ml-3"
                                        type="button"
                                        style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                                        @click="clearData"
                                    >
                                      Сбросить фильтр
                                    </button>
                                  </template>
                                </v-card-actions>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                        <v-calendar
                            v-if="!dialogDate"
                            ref="weeklyCalendar"
                            v-model="focus"
                            locale="ru"
                            :type="type"
                            :weekdays="[1,2,3,4,5,6,0]"
                            :short-intervals="false"
                            :interval-count="getIntervalCount(toggle_day)"
                            :interval-height="82"
                            :first-time="toggle_day === 0 || toggle_day === 2 ? '03:00' : '14:00'"
                            :events="events"
                            event-overlap-mode="column"
                            class="custom__calendar"
                            @change="updateRange"
                        >
                          <template v-slot:day-label-header>
                            <span></span>
                          </template>
                          <template v-slot:event="{ eventParsed }">
                            <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                              <div style="padding: 10px">
                                <div class="d-flex justify-space-between align-center">
                                  <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                  <div class="event-count">{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                                </div>
                                <div class="event-name">{{ eventParsed.input.name }}</div>
                              </div>
                            </router-link>
                          </template>
                        </v-calendar>
                        <v-calendar
                            v-if="dialogDate"
                            ref="dailyCalendar"
                            locale="ru"
                            :start="dateTable"
                            :type="type"
                            :weekdays="[1,2,3,4,5,6,0]"
                            :short-intervals="false"
                            :interval-count="getIntervalCount(toggle_day)"
                            :interval-height="82"
                            :first-time="toggle_day === 0 || toggle_day === 2 ? '03:00' : '14:00'"
                            :events="events"
                            class="custom__calendar"
                        >
                          <template v-slot:day-label-header>
                            <span></span>
                          </template>
                          <template v-slot:event="{ eventParsed }">
                            <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                              <div style="padding: 10px">
                                <div class="d-flex justify-space-between align-center">
                                  <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                  <div class="event-count">{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                                </div>
                                <div class="event-name">{{ eventParsed.input.name }}</div>
                              </div>
                            </router-link>
                          </template>
                        </v-calendar>
                      </v-sheet>
                    </v-tab-item>
                    <v-tab-item>
                      <v-sheet class="rounded-lg">
                        <v-card-title
                            class="d-flex justify-space-between align-center"
                        >
                          <div class="calendar-options d-flex align-center">
                            <VueDatePicker
                                no-title
                                no-header
                                color="#629f34"
                                v-model="date"
                                style="flex: none !important;"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__date-button"
                                    ref="activator"
                                    type="button"
                                >
                                  <v-icon
                                      dark
                                      small
                                      class="mr-2"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon>  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>
                            <v-btn-toggle
                                v-model="toggle_day"
                                mandatory
                                class="ml-5 rounded-lg"
                            >
                              <v-btn>
                                Утро
                              </v-btn>
                              <v-btn>
                                Вечер
                              </v-btn>
                              <v-btn>
                                Весь день
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                          <div class="filter-schedule">
                            <v-btn
                                dark
                                class="filter-button"
                                @click="dialogFiler_indiv = !dialogFiler_indiv"
                            >
                              <img
                                  class="mr-1"
                                  src="/playground_assets/mediumfilter.svg"
                              >
                              Фильтр
                            </v-btn>
                          </div>
                        </v-card-title>
                        <v-card-text
                            v-show="dialogFiler_indiv"
                        >
                          <v-form
                              ref="indivFilterForm"
                              v-model="valid_indiv"
                          >
                            <v-container>
                              <v-row>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                >
                                  <label>Сотрудники</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="indivLessonFilter.specialist"
                                      :items="clientEvents"
                                      item-value="specialist_id"
                                      item-text="specialist_name"
                                      ref="selectedEl1"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      item-color="#629F33"
                                      clearable
                                      multiple
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  >
                                    <template v-slot:selection="data">
                                      <span
                                          v-if="indivLessonFilter.specialist.length === 1"
                                          v-bind="data.attrs"
                                      >
                                        {{ data.item.category }}
                                      </span>
                                      <div v-else-if="data.index === 0">
                                        Выбрано {{ indivLessonFilter.specialist.length }} сотрудников
                                      </div>
                                    </template>
                                  </v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                >
                                  <label>Должность</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="indivLessonFilter.position"
                                      :items="clientEvents"
                                      item-value="post_id"
                                      item-text="post_name"
                                      ref="selectedEl3"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                >
                                  <label>Помещение</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="indivLessonFilter.room"
                                      :items="clientEvents"
                                      item-value="room_id"
                                      item-text="room_name"
                                      ref="selectedEl4"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                    class="mt-3"
                                >
                                  <label>Клиент</label>
                                  <v-autocomplete
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      :items="listClient ? listClient.client : []"
                                      item-value="client_id"
                                      item-text="name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      no-data-text="Результатов не найдено"
                                      :search-input.sync="indivLessonFilter.search_client"
                                      v-model="indivLessonFilter.select_client"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                    class="mt-3"
                                >
                                  <label>Услуга</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="indivLessonFilter.service"
                                      :items="clientEvents"
                                      ref="selectedEl6"
                                      item-text="name"
                                      item-value="service_id"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="4"
                                    class="mt-3"
                                >
                                  <label>Статус</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="indivLessonFilter.status"
                                      :items="statusTypes"
                                      ref="selectedEl2"
                                      item-text="type_name"
                                      item-value="type_id"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-card-actions class="mt-4">
                                  <template v-if="!dialogButton_indiv">
                                    <button
                                        class="button custom__button mt-5"
                                        type="button"
                                    >
                                      Применить
                                    </button>
                                  </template>
                                  <template v-else>
                                    <button
                                        class="button custom__button mt-5"
                                        type="button"
                                        style="background-color: #A13453 !important;color: #fff !important;"
                                        @click="filterEvents(indivLessonFilter)"
                                    >
                                      Применить
                                    </button>
                                    <button
                                        class="button custom__button mt-5 ml-3"
                                        type="button"
                                        style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                                        @click="clearData"
                                    >
                                      Сбросить фильтр
                                    </button>
                                  </template>
                                </v-card-actions>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                        <v-calendar
                            ref="calendar"
                            locale="ru"
                            type="category"
                            category-show-all
                            :start="date"
                            :categories="categories"
                            :events="clientEvents"
                            :short-intervals="false"
                            :interval-count="getIntervalCount(toggle_day)"
                            :interval-height="82"
                            :first-time="toggle_day === 0 || toggle_day === 2 ? '03:00' : '14:00'"
                            class="custom__client-calendar"
                        >
                          <template v-slot:day-label-header>
                            <span></span>
                          </template>
                          <template v-slot:event="{ eventParsed }">
                            <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                              <div style="padding: 10px">
                                <div class="d-flex justify-space-between align-center">
                                  <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                  <div class="event-count">{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                                </div>
                                <div class="event-name">{{ eventParsed.input.name }}</div>
                              </div>
                            </router-link>
                          </template>
                        </v-calendar>
                      </v-sheet>
                    </v-tab-item>
                    <v-tab-item>
                      <v-sheet class="rounded-lg">
                        <v-card-title
                            class="d-flex justify-space-between align-center"
                        >
                          <div class="calendar-options d-flex align-center">
                            <v-btn-toggle
                                v-model="toggle_date_all"
                                mandatory
                                class="ml-5 rounded-lg"
                            >
                              <v-btn @click="changeDay">
                                День
                              </v-btn>
                              <v-btn @click="changeWeek">
                                Неделя
                              </v-btn>
                            </v-btn-toggle>
                            <v-btn-toggle
                                v-model="toggle_week_all"
                                class="ml-5 rounded-lg"
                            >
                              <v-btn @click="prevAll" style="padding: 0 !important; min-width: 38px !important;">
                                <v-icon
                                >
                                  mdi-chevron-left
                                </v-icon>
                              </v-btn>
                              <v-btn @click="nextAll" style="padding: 0 !important; min-width: 38px !important;">
                                <v-icon
                                >
                                  mdi-chevron-right
                                </v-icon>
                              </v-btn>
                            </v-btn-toggle>
                            <VueDatePicker
                                no-title
                                no-header
                                disabled
                                color="#629f34"
                                class="ml-4"
                                style="flex: none !important;"
                                v-if="start_all && end_all && !dialogDate_all"
                            >
                              <template #activator>
                                <button
                                    class="button custom__date-button"
                                    ref="activator"
                                    type="button"
                                >
                                  <v-icon
                                      dark
                                      small
                                      class="mr-2"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon>  {{ start_all.day === end_all.day ? start_all.day : start_all.day + '-' + end_all.day }} {{ start_all.month === end_all.month ? months[start_all.month - 1] : months[start_all.month - 1] + ' - ' + months[end_all.month - 1]}}
                                </button>
                              </template>
                            </VueDatePicker>
                            <VueDatePicker
                                no-title
                                no-header
                                v-model="dateTable_all"
                                @onChange="typeToDate(dateTable_all)"
                                color="#629f34"
                                class="ml-4"
                                style="flex: none !important;"
                                v-if="dialogDate_all"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__date-button"
                                    ref="activator"
                                    type="button"
                                >
                                  <v-icon
                                      dark
                                      small
                                      class="mr-2"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon> {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>
                            <v-btn-toggle
                                v-model="toggle_day_all"
                                mandatory
                                class="ml-5 rounded-lg"
                            >
                              <v-btn>
                                Утро
                              </v-btn>
                              <v-btn>
                                Вечер
                              </v-btn>
                              <v-btn>
                                Весь день
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                          <div class="filter-schedule">
                            <v-btn
                                dark
                                class="filter-button"
                                @click="dialogFiler_all = !dialogFiler_all"
                            >
                              <img
                                  class="mr-1"
                                  src="/playground_assets/mediumfilter.svg"
                              >
                              Фильтр
                            </v-btn>
                          </div>
                        </v-card-title>
                        <v-card-text
                            v-show="dialogFiler_all"
                        >
                          <v-form
                              ref="allFilterForm"
                              v-model="valid_all"
                          >
                            <v-container>
                              <v-row>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="3"
                                >
                                  <label>Сотрудники</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="allLessonFilter.specialist"
                                      :items="allEvents"
                                      item-value="specialist_id"
                                      item-text="category"
                                      ref="selectedEl1"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      item-color="#629F33"
                                      clearable
                                      multiple
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  >
                                    <template v-slot:selection="data">
                                      <span
                                          v-if="allLessonFilter.specialist.length === 1"
                                          v-bind="data.attrs"
                                      >
                                        {{ data.item.category }}
                                      </span>
                                      <div v-else-if="data.index === 0">
                                        Выбрано {{ allLessonFilter.specialist.length }} сотрудников
                                      </div>
                                    </template>
                                  </v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="3"
                                >
                                  <label>Тип</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      :items="[{type: 'Новый'}]"
                                      ref="selectedEl2"
                                      item-text="type"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="3"
                                >
                                  <label>Должность</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="allLessonFilter.position"
                                      :items="allEvents"
                                      item-value="post_id"
                                      item-text="post_name"
                                      ref="selectedEl3"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="3"
                                >
                                  <label>Помещение</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="allLessonFilter.room"
                                      :items="allEvents"
                                      item-value="room_id"
                                      item-text="room_name"
                                      ref="selectedEl4"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="3"
                                    class="mt-3"
                                >
                                  <label>Клиент</label>
                                  <v-autocomplete
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      :items="listClient ? listClient.client : []"
                                      item-value="client_id"
                                      item-text="name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      no-data-text="Результатов не найдено"
                                      :search-input.sync="allLessonFilter.search_client"
                                      v-model="allLessonFilter.select_client"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="3"
                                    class="mt-3"
                                >
                                  <label>Услуга</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="allLessonFilter.service"
                                      :items="allEvents"
                                      ref="selectedEl6"
                                      item-text="name"
                                      item-value="service_id"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="3"
                                    class="mt-3"
                                >
                                  <label>Статус</label>
                                  <v-select
                                      @input="collectData"
                                      class="rounded-lg custom__select"
                                      v-model="allLessonFilter.status"
                                      :items="statusTypes"
                                      ref="selectedEl2"
                                      item-text="type_name"
                                      item-value="type_id"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Выбрать"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      color="#629F33"
                                      style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    md="3"
                                >
  
                                </v-col>
                                <v-card-actions class="mt-4">
                                  <template v-if="!dialogButton_all">
                                    <button
                                        class="button custom__button mt-5"
                                        type="button"
                                    >
                                      Применить
                                    </button>
                                  </template>
                                  <template v-else>
                                    <button
                                        class="button custom__button mt-5"
                                        type="button"
                                        style="background-color: #A13453 !important;color: #fff !important;"
                                        @click="filterEvents(allLessonFilter)"
                                    >
                                      Применить
                                    </button>
                                    <button
                                        class="button custom__button mt-5 ml-3"
                                        type="button"
                                        style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                                        @click="clearData"
                                    >
                                      Сбросить фильтр
                                    </button>
                                  </template>
                                </v-card-actions>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                        <v-calendar
                            v-if="!dialogDate_all"
                            ref="weeklyAllCalendar"
                            v-model="focus_all"
                            locale="ru"
                            :type="type_all"
                            :weekdays="[1,2,3,4,5,6,0]"
                            :short-intervals="false"
                            :interval-count="getIntervalCount(toggle_day_all)"
                            :interval-height="82"
                            :first-time="toggle_day_all === 0 || toggle_day_all === 2 ? '03:00' : '14:00'"
                            :events="allEvents"
                            event-overlap-mode="column"
                            class="custom__calendar"
                            @change="updateRangeAll"
                        >
                          <template v-slot:day-label-header>
                            <span></span>
                          </template>
                          <template v-slot:event="{ eventParsed }">
                            <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                              <div style="padding: 10px">
                                <div class="d-flex justify-space-between align-center">
                                  <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                  <div class="event-count">{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                                </div>
                                <div class="event-name">{{ eventParsed.input.name }}</div>
                              </div>
                            </router-link>
                          </template>
                        </v-calendar>
                        <v-calendar
                            v-if="dialogDate_all"
                            ref="dailyAllCalendar"
                            locale="ru"
                            :start="dateTable_all"
                            :type="type_all"
                            :weekdays="[1,2,3,4,5,6,0]"
                            :short-intervals="false"
                            :interval-count="getIntervalCount(toggle_day_all)"
                            :interval-height="82"
                            :first-time="toggle_day_all === 0 || toggle_day_all === 2 ? '03:00' : '14:00'"
                            :events="allEvents"
                            class="custom__calendar"
                        >
                          <template v-slot:day-label-header>
                            <span></span>
                          </template>
                          <template v-slot:event="{ eventParsed }">
                            <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                              <div style="padding: 10px">
                                <div class="d-flex justify-space-between align-center">
                                  <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                  <div class="event-count">{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                                </div>
                                <div class="event-name">{{ eventParsed.input.name }}</div>
                              </div>
                            </router-link>
                          </template>
                        </v-calendar>
                      </v-sheet>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-container>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
  </template>
  
  <script>
  import AdminHeader from '@/components/Admin/AdminHeader.vue';
  import AdminMenu from '@/components/Admin/AdminMenu.vue';
  import {VueDatePicker} from "@mathieustan/vue-datepicker";
  import {scheduleActionTypes} from "@/store/modules/schedule";
  import {clientActionTypes} from '@/store/modules/client';
  import {mapState} from "vuex";
  
  export default {
    name: 'AdminLessons',
    components: {
      VueDatePicker,
      AdminHeader,
      AdminMenu
    },
    data() {
      return {
        date: new Date(),
        start: null,
        end: null,
        dateTable: new Date(),
        start_all: null,
        end_all: null,
        dateTable_all: new Date(),
        endDay: null,
        endMonth: null,
        focus: '',
        focus_all: '',
        valid: true,
        valid_indiv: true,
        valid_all: true,
        selected: [],
        selected_indiv: [],
        selected_all: [],
        groupLessonFilter: {
          specialist: null,
          position: null,
          room: null,
          search_client: '',
          select_client: null,
          service: null,
          status: null,
        },
        indivLessonFilter: {
          specialist: null,
          position: null,
          room: null,
          search_client: '',
          select_client: null,
          service: null,
          status: null,
        },
        allLessonFilter: {
          specialist: null,
          lesson: null,
          position: null,
          room: null,
          search_client: '',
          select_client: null,
          service: null,
          status: null,
        },
        lessonTypes: [
          {type_id: 0, type_name: 'Персональное занятие'},
          {type_id: 1, type_name: 'Групповое занятие'}
        ],
        statusTypes: [
          {type_id: 0, type_name: 'Запланировано'},
          {type_id: 1, type_name: 'Выполнено'},
          {type_id: 2, type_name: 'Отменено'},
        ],
        toggle_date: 1,
        toggle_date_all: 1,
        toggle_category: 0,
        type: 'week',
        type_all: 'week',
        toggle_week: null,
        toggle_week_all: null,
        toggle_day: 2,
        toggle_day_all: 2,
        dialogDate: false,
        dialogDate_all: false,
        dialogFiler: false,
        dialogFiler_indiv: false,
        dialogFiler_all: false,
        dialogButton: false,
        dialogButton_indiv: false,
        dialogButton_all: false,
        schedule_tab: null,
        schedules: [
          {tab: 'Групповые занятия'},
          {tab: 'Индивидуальные занятия'},
          {tab: 'Все'},
        ],
        categories: [],
        events: [
            {
                "id": "923dba0d-5322-4575-bdd9-7b56565f8939",
                "name": "Льготная группа ЙОГА (клевер)",
                "service_id": "104aa8bc-22a5-11ec-a060-60e32700ce56",
                "start": "2023-07-26T08:00:00",
                "end": "2023-07-26T08:55:00",
                "color": "#9370DB",
                "category": "Каменева Виктория Николаевна",
                "timed": false,
                "slots": "Unlimited",
                "specialist_id": "987d875d-e9e8-11ea-8125-9c5c8e747603",
                "specialist_name": "Каменева Виктория Николаевна",
                "room_name": "Студия №1 (клевер)",
                "room_id": "49ea446e-e911-11ea-8125-9c5c8e747603",
                "post_id": "5b7394d6-ff24-11ea-8136-9c5c8e747603",
                "post_name": "Инструктор групповых программ (премиум) (клевер)",
                "status": 0,
                "count": 0
            },
            {
                "id": "705e7f77-7018-45ca-9380-d43817159db1",
                "name": "HIIT (клевер)",
                "service_id": "c4ec3f3e-c1f5-11eb-a060-60e32700ce56",
                "start": "2023-07-26T10:00:00",
                "end": "2023-07-26T10:45:00",
                "color": "#FF0000",
                "category": "Аюпова Александра Евгеньевна",
                "timed": false,
                "slots": 20,
                "specialist_id": "f14f8a75-e9e8-11ea-8125-9c5c8e747603",
                "specialist_name": "Аюпова Александра Евгеньевна",
                "room_name": "Студия №3 (клевер)",
                "room_id": "aefb39b6-e9f5-11ea-8125-9c5c8e747603",
                "post_id": "0639db09-ff26-11ea-8136-9c5c8e747603",
                "post_name": "Инструктор групповых программ (элит) (клевер)",
                "status": 0,
                "count": 0
            }
        ],
        clientEvents: [
            {
                    "id": "cba52345-8567-48b1-ab7b-1f3f2c068d3f",
                    "name": "HIIT (клевер)",
                "service_id": "c4ec3f3e-c1f5-11eb-a060-60e32700ce56",
                "start": "2023-07-26T10:00:00",
                "end": "2023-07-26T10:45:00",
                "color": "#FF0000",
                "category": "Аюпова Александра Евгеньевна",
                "timed": false,
                "slots": 20,
                "specialist_id": "f14f8a75-e9e8-11ea-8125-9c5c8e747603",
                "specialist_name": "Аюпова Александра Евгеньевна",
                "room_name": "Студия №3 (клевер)",
                "room_id": "aefb39b6-e9f5-11ea-8125-9c5c8e747603",
                "post_id": "0639db09-ff26-11ea-8136-9c5c8e747603",
                "post_name": "Инструктор групповых программ (элит) (клевер)",
                "status": 0,
                "count": 0
            }
        ],
        allEvents: [
            {
                "id": "923dba0d-5322-4575-bdd9-7b56565f8939",
                "name": "Льготная группа ЙОГА (клевер)",
                "service_id": "104aa8bc-22a5-11ec-a060-60e32700ce56",
                "start": "2023-07-26T08:00:00",
                "end": "2023-07-26T08:55:00",
                "color": "#9370DB",
                "category": "Каменева Виктория Николаевна",
                "timed": false,
                "slots": "Unlimited",
                "lesson_type": 1,
                "specialist_id": "987d875d-e9e8-11ea-8125-9c5c8e747603",
                "specialist_name": "Каменева Виктория Николаевна",
                "room_name": "Студия №1 (клевер)",
                "room_id": "49ea446e-e911-11ea-8125-9c5c8e747603",
                "post_id": "5b7394d6-ff24-11ea-8136-9c5c8e747603",
                "post_name": "Инструктор групповых программ (премиум) (клевер)",
                "status": 0,
                "count": 0
            },
            {
                "id": "4c21b683-336a-4789-858c-e8cc5056074e",
                "name": "Платная секция \"CrossFit Progress\" ,(клевер)",
                "service_id": "43a14c61-9080-11eb-a05f-60e32700ce56",
                "start": "2023-07-26T08:30:00",
                "end": "2023-07-26T09:25:00",
                "color": "#FFFF00",
                "category": "Бикмуллин Айрат Равилевич",
                "timed": false,
                "slots": "Unlimited",
                "lesson_type": 1,
                "specialist_id": "0734f1d1-e9f7-11ea-8125-9c5c8e747603",
                "specialist_name": "Бикмуллин Айрат Равилевич",
                "room_name": "Тренажерный зал (клевер)",
                "room_id": "38ac8ce7-f984-11ea-8136-9c5c8e747603",
                "post_id": "935854fa-ff24-11ea-8136-9c5c8e747603",
                "post_name": "Инструктор тренажёрного зала (элит) (клевер)",
                "status": 0,
                "count": 0
            },
            {
                "id": "7b9de512-b69f-4cda-b678-2b512c301c3e",
                "name": "Functional training (7-14 лет) (клевер)",
                "service_id": "633ccfcb-55d0-11ed-a063-60e32700ce56",
                "start": "2023-07-26T19:00:00",
                "end": "2023-07-26T19:45:00",
                "color": "#87CEEB",
                "category": "Толстова Екатерина Валерьевна",
                "timed": false,
                "slots": "Unlimited",
                "lesson_type": 1,
                "specialist_id": "5d5fb1bc-a34b-11eb-a05f-60e32700ce56",
                "specialist_name": "Толстова Екатерина Валерьевна",
                "room_name": "Студия №2 (клевер)",
                "room_id": "b86aa990-e9f5-11ea-8125-9c5c8e747603",
                "post_id": "639ca79b-ff40-11ea-8136-9c5c8e747603",
                "post_name": "Инструктор детского фитнеса \"Тренер\" (клевер)",
                "status": 0,
                "count": 0
            }
        ],
        months: [
          'январь',
          'февраль',
          'март',
          'апрель',
          'май',
          'июнь',
          'июль',
          'август',
          'сентябрь',
          'октябрь',
          'ноябрь',
          'декабрь'
        ],
      }
    },
    computed: {
      ...mapState({
        isLoading: state => state.schedule.isLoading,
        listClient: state => state.client.listClient,
        schedule: state => state.schedule.data,
        validationErrors: state => state.schedule.validationErrors,
      })
    },
    methods: {
      collectData(selected){
        if (this.schedule_tab === 0) {
          this.selected.push(selected)
          this.dialogButton = true;
        }
        if (this.schedule_tab === 1) {
          this.selected_indiv.push(selected)
          this.dialogButton_indiv = true;
        }
        if (this.schedule_tab === 2) {
          this.selected_all.push(selected)
          this.dialogButton_all = true;
        }
      },
      clearData(){
        // if (this.schedule_tab === 0) {
        //   this.$refs.groupFilterForm.reset();
        //   this.selected.length = 0;
        //   this.dialogButton = false;
        //   if (this.toggle_date === 0) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.dateTable,
        //       end_date: this.dateTable
        //     }).then((response) => {
        //       this.events = response.schedule?.group
        //     })
        //   }
        //   if (this.toggle_date === 1) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.start.date,
        //       end_date: this.end.date
        //     }).then((response) => {
        //       this.events = response.schedule?.group
        //     })
        //   }
        // }
        // if (this.schedule_tab === 1) {
        //   this.$refs.indivFilterForm.reset();
        //   this.selected_indiv.length = 0;
        //   this.dialogButton_indiv = false;
        //   if (this.toggle_category === 0) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.date,
        //       end_date: this.date
        //     }).then((response) => {
        //       this.clientEvents = response.schedule?.indiv
        //       let categories = [];
        //       for (let item of this.clientEvents) {
        //         if(categories.indexOf(item.category) === -1) {
        //           categories.push(item.category)
        //         }
        //       }
        //       this.categories = categories;
        //     })
        //   } else {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.date,
        //       end_date: this.date
        //     }).then((response) => {
        //       for (let item of response.schedule?.indiv) {
        //         item.category = item.room_name
        //       }
        //       this.clientEvents = response.schedule?.indiv
        //       let categories = [];
        //       for (let item of this.clientEvents) {
        //         if(categories.indexOf(item.category) === -1) {
        //           categories.push(item.category)
        //         }
        //       }
        //       this.categories = categories;
        //     })
        //   }
        // }
        // if (this.schedule_tab === 2) {
        //   this.$refs.allFilterForm.reset();
        //   this.selected_all.length = 0;
        //   this.dialogButton_all = false;
        //   if (this.toggle_date_all === 0) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.dateTable_all,
        //       end_date: this.dateTable_all
        //     }).then((response) => {
        //       this.allEvents = response.schedule?.all
        //     })
        //   }
        //   if (this.toggle_date_all === 1) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.start_all.date,
        //       end_date: this.end_all.date
        //     }).then((response) => {
        //       this.allEvents = response.schedule?.all
        //     })
        //   }
        // }
      },
      typeToDate(date) {
        if (this.schedule_tab === 0) {
          this.dateTable = new Date(date);
        }
        if (this.schedule_tab === 2) {
          this.dateTable_all = new Date(date);
        }
      },
      prev () {
        this.dialogDate ? this.dateTable = new Date(this.dateTable.setDate(this.dateTable.getDate() - 1)) : this.$refs.weeklyCalendar.prev()
      },
      prevAll () {
        this.dialogDate_all ? this.dateTable_all = new Date(this.dateTable_all.setDate(this.dateTable_all.getDate() - 1)) : this.$refs.weeklyAllCalendar.prev()
      },
      next () {
        this.dialogDate ? this.dateTable = new Date(this.dateTable.setDate(this.dateTable.getDate() + 1)) : this.$refs.weeklyCalendar.next()
      },
      nextAll () {
        this.dialogDate_all ? this.dateTable_all = new Date(this.dateTable_all.setDate(this.dateTable_all.getDate() + 1)) : this.$refs.weeklyAllCalendar.next()
      },
      updateRange ({ start, end }) {
          this.start = start;
          this.end = end;
        //   this.events = [];
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.start.date,
        //     end_date: this.end.date
        //   }).then((response) => {
        //     this.events = response.schedule?.group
        //   })
      },
      updateRangeAll ({ start,end }) {
        this.start_all = start;
        this.end_all = end;
        // this.allEvents = [];
        // this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //   start_date: this.start_all.date,
        //   end_date: this.end_all.date
        // }).then((response) => {
        //   this.allEvents = response.schedule?.all
        // })
      },
      changeDay() {
        if (this.schedule_tab === 0) {
          this.type = 'day';
          this.dialogDate = true;
        }
        if (this.schedule_tab === 2) {
          this.type_all = 'day';
          this.dialogDate_all = true;
        }
      },
      changeWeek() {
        if (this.schedule_tab === 0) {
          this.type_all = 'week';
          this.dialogDate_all = false;
        }
        if (this.schedule_tab === 2) {
          this.type_all = 'week';
          this.dialogDate_all = false;
        }
      },
      getIntervalCount(value) {
        let count = 19;
        if (value === 0) {
          count = 11;
        }
        if (value === 1) {
          count = 8;
        }
        return count
      },
      filterEvents(lesson) {
        if (this.schedule_tab === 0) {
          if (lesson.specialist.length > 0) {
            this.events = this.events.filter((item) => lesson.specialist.includes(item.specialist_id));
          }
          if (lesson.position !== null) {
            this.events = this.events.filter((item) => item.post_id === lesson.position);
          }
          if (lesson.room !== null) {
            this.events = this.events.filter((item) => item.room_id === lesson.room);
          }
          if (lesson.select_client !== null) {
            this.events = this.events.filter((item) => {
              for (let client of item.client_list) {
                return client.client_id === lesson.select_client
              }
            });
          }
          if (lesson.service !== null) {
            this.events = this.events.filter((item) => item.service_id === lesson.service);
          }
          if (lesson.status !== null) {
            this.events = this.events.filter((item) => item.status === lesson.status);
          }
        }
        if (this.schedule_tab === 1) {
          if (lesson.specialist.length > 0) {
            this.clientEvents = this.clientEvents.filter((item) => lesson.specialist.includes(item.specialist_id));
          }
          if (lesson.position !== null) {
            this.clientEvents = this.clientEvents.filter((item) => item.post_id === lesson.position);
          }
          if (lesson.room !== null) {
            this.clientEvents = this.clientEvents.filter((item) => item.room_id === lesson.room);
          }
          if (lesson.select_client !== null) {
            this.clientEvents = this.clientEvents.filter((item) => {
              for (let client of item.client_list) {
                return client.client_id === lesson.select_client
              }
            });
          }
          if (lesson.service !== null) {
            this.clientEvents = this.clientEvents.filter((item) => item.service_id === lesson.service);
          }
          if (lesson.status !== null) {
            this.clientEvents = this.clientEvents.filter((item) => item.status === lesson.status);
          }
        }
        if (this.schedule_tab === 2) {
          if (lesson.specialist.length > 0) {
            this.allEvents = this.allEvents.filter((item) => lesson.specialist.includes(item.specialist_id));
          }
          if (lesson.lesson !== null) {
            this.allEvents = this.allEvents.filter((item) => item.lesson_type === lesson.lesson);
          }
          if (lesson.position !== null) {
            this.allEvents = this.allEvents.filter((item) => item.post_id === lesson.position);
          }
          if (lesson.room !== null) {
            this.allEvents = this.allEvents.filter((item) => item.room_id === lesson.room);
          }
          if (lesson.select_client !== null) {
            this.allEvents = this.allEvents.filter((item) => {
              for (let client of item.client_list) {
                return client.client_id === lesson.select_client
              }
            });
          }
          if (lesson.service !== null) {
            this.allEvents = this.allEvents.filter((item) => item.service_id === lesson.service);
          }
          if (lesson.status !== null) {
            this.allEvents = this.allEvents.filter((item) => item.status === lesson.status);
          }
        }
      }
    },
    watch: {
    //   'groupLessonFilter.search_client'() {
    //     if (this.groupLessonFilter.search_client !== '') {
    //       this.$store.dispatch(clientActionTypes.searchClient, {
    //         client_field: this.groupLessonFilter.search_client
    //       })
    //     }
    //   },
    //   'indivLessonFilter.search_client'() {
    //     if (this.indivLessonFilter.search_client !== '') {
    //       this.$store.dispatch(clientActionTypes.searchClient, {
    //         client_field: this.indivLessonFilter.search_client
    //       })
    //     }
    //   },
    //   'allLessonFilter.search_client'() {
    //     if (this.allLessonFilter.search_client !== '') {
    //       this.$store.dispatch(clientActionTypes.searchClient, {
    //         client_field: this.allLessonFilter.search_client
    //       })
    //     }
    //   },
      toggle_category() {
        // if (this.toggle_category === 0) {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.date,
        //     end_date: this.date
        //   }).then((response) => {
        //     this.clientEvents = response.schedule?.indiv
        //     let categories = [];
        //     for (let item of this.clientEvents) {
        //       if(categories.indexOf(item.category) === -1) {
        //         categories.push(item.category)
        //       }
        //     }
        //     this.categories = categories;
        //   })
        // } else {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.date,
        //     end_date: this.date
        //   }).then((response) => {
        //     for (let item of response.schedule?.indiv) {
        //       item.category = item.room_name
        //     }
        //     this.clientEvents = response.schedule?.indiv
        //     let categories = [];
        //     for (let item of this.clientEvents) {
        //       if(categories.indexOf(item.category) === -1) {
        //         categories.push(item.category)
        //       }
        //     }
        //     this.categories = categories;
        //   })
        // }
      },
      date() {
        // if (this.schedule_tab === 1) {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.date,
        //     end_date: this.date
        //   }).then((response) => {
        //     this.clientEvents = response.schedule?.indiv
        //     let categories = [];
        //     for (let item of this.clientEvents) {
        //       if(categories.indexOf(item.category) === -1) {
        //         categories.push(item.category)
        //       }
        //     }
        //     this.categories = categories;
        //   })
        // }
      },
      schedule_tab() {
        // if (this.schedule_tab === 0 && this.$refs.groupFilterForm) {
        //   this.$refs.groupFilterForm.reset();
        //   this.selected.length = 0;
        //   this.dialogButton = false;
        //   this.dialogFiler = false;
        //   if (this.toggle_date === 0) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.dateTable,
        //       end_date: this.dateTable
        //     }).then((response) => {
        //       this.events = response.schedule?.group
        //     })
        //   }
        //   if (this.toggle_date === 1) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.start.date,
        //       end_date: this.end.date
        //     }).then((response) => {
        //       this.events = response.schedule?.group
        //     })
        //   }
        // }
        // if (this.schedule_tab === 1 && this.$refs.indivFilterForm) {
        //   this.$refs.indivFilterForm.reset();
        //   this.selected_indiv.length = 0;
        //   this.dialogButton_indiv = false;
        //   this.dialogFiler_indiv = false;
        //   if (this.toggle_category === 0) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.date,
        //       end_date: this.date
        //     }).then((response) => {
        //       this.clientEvents = response.schedule?.indiv
        //       let categories = [];
        //       for (let item of this.clientEvents) {
        //         if(categories.indexOf(item.category) === -1) {
        //           categories.push(item.category)
        //         }
        //       }
        //       this.categories = categories;
        //     })
        //   } else {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.date,
        //       end_date: this.date
        //     }).then((response) => {
        //       for (let item of response.schedule?.indiv) {
        //         item.category = item.room_name
        //       }
        //       this.clientEvents = response.schedule?.indiv
        //       let categories = [];
        //       for (let item of this.clientEvents) {
        //         if(categories.indexOf(item.category) === -1) {
        //           categories.push(item.category)
        //         }
        //       }
        //       this.categories = categories;
        //     })
        //   }
        // }
        // if (this.schedule_tab === 2 && this.$refs.allFilterForm) {
        //   this.$refs.allFilterForm.reset();
        //   this.selected_all.length = 0;
        //   this.dialogButton_all = false;
        //   this.dialogFiler_all = false;
        //   if (this.toggle_date_all === 0) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.dateTable_all,
        //       end_date: this.dateTable_all
        //     }).then((response) => {
        //       this.allEvents = response.schedule?.all
        //     })
        //   }
        //   if (this.toggle_date_all === 1) {
        //     this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //       start_date: this.start_all.date,
        //       end_date: this.end_all.date
        //     }).then((response) => {
        //       this.allEvents = response.schedule?.all
        //     })
        //   }
        // }
      },
      dateTable() {
        if (this.toggle_date === 0) {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.dateTable,
        //     end_date: this.dateTable
        //   }).then((response) => {
        //     this.events = response.schedule?.group
        //   })
        }
      },
      dateTable_all() {
        if (this.toggle_date_all === 0) {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.dateTable_all,
        //     end_date: this.dateTable_all
        //   }).then((response) => {
        //     this.allEvents = response.schedule?.all
        //   })
        }
      },
      toggle_date() {
        if (this.toggle_date === 0) {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.dateTable,
        //     end_date: this.dateTable
        //   }).then((response) => {
        //     this.events = response.schedule?.group
        //   })
        }
        if (this.toggle_date === 1) {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.start.date,
        //     end_date: this.end.date
        //   }).then((response) => {
        //     this.events = response.schedule?.group
        //   })
        }
      },
      toggle_date_all() {
        if (this.toggle_date_all === 0) {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.dateTable_all,
        //     end_date: this.dateTable_all
        //   }).then((response) => {
        //     this.allEvents = response.schedule?.all
        //   })
        }
        if (this.toggle_date_all === 1) {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.start_all.date,
        //     end_date: this.end_all.date
        //   }).then((response) => {
        //     this.allEvents = response.schedule?.all
        //   })
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .custom__calendar {
    overflow-y: hidden;
  }
  .event-time {
    font-family: 'Circe';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: #000;
  }
  .event-count {
    padding: 2px 4px;
    background: #1A1A1A;
    border-radius: 2px;
    color: #fff;
  }
  .event-name {
    padding-top: 10px;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
    color: #000;
  }
  .event-location {
    padding-top: 4px;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: #000;
  }
  .range-week {
    display: inline-block;
    margin-left: 12px;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: #629F33;
  }
  .custom__button {
    width: 121px !important;
    height: 38px;
    display: flex;
    gap: 4px;
    padding: 5px 10px;
    position: relative;
    box-sizing: content-box;
    align-items: center;
    flex-shrink: 0;
    border-radius: 12px !important;
    margin-top: 0 !important;
    justify-content: center;
    background-color: #F1F1F1 !important;
    font-size: 16px;
    font-weight: 700;
    color: #1A1A1A!important;
  }
  .custom__date-button {
    width: 180px;
    height: 23px;
    display: flex;
    padding: 7px;
    max-width: 180px;
    position: relative;
    box-sizing: content-box;
    align-items: center;
    flex-shrink: 0;
    margin-right: 0;
    border-radius: 12px;
    margin-bottom: 0;
    justify-content: center;
    background-color: var(--dl-color-default-primarysuccess) !important;
    font-size: 16px;
    line-height: 24px;
    color: #fff!important;
  }
  .custom__select.v-select--is-menu-active {
    outline: 4px solid #E0ECD6;
  }
  
  .theme--light.v-btn.v-btn--has-bg {
    background-color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-transform: none;
  }
  .theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
    opacity: 0!important;
  }
  </style>